import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import CommonCaseCard from "../../components/CommonCaseCard/CommonCaseCard";

export const CaseCard = ({ selectCards, cardClass, casetype }) => {
  const caseType = casetype === "submittedcases" ? "Submitted" : "";

  return (
    <div className={casetype}>
      {selectCards?.map((item, index) => {
        // Format the 'Submitted Date' field
        const cardDetail = item.map((field) => {
          if (field.label === "Submitted Date" && field.value) {
            const date = new Date(field.value);
            const formatted = `${String(date.getDate()).padStart(2, "0")}/${String(
              date.getMonth() + 1
            ).padStart(2, "0")}/${date.getFullYear()}`;
            return { ...field, value: formatted };
          }
          return field;
        });
          const submittedField = cardDetail.find((i) => i.label === "Submitted Date");
          const formattedSubmittedDate = submittedField?.value || "-";
        return (
          <CommonCaseCard
            key={index}
            cardClass={cardClass}
            cardDetail={cardDetail}
            btn={false}
            caseType={caseType}
            formattedSubmittedDate={formattedSubmittedDate}
          />
        );
      })}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({});

export default connect(mapStateToProps)(CaseCard);
